module.exports = __webpack_public_path__ + "static/media/14.b2a1c809.png";